var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeaking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Speaking_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Speaking_",
    "data-name": "Speaking ",
    clipPath: "url(#clip-Speaking_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-volume-up",
    "data-name": "Icon material-volume-up",
    d: "M4.5,11.651v7.078H9.218l5.9,5.9V5.753l-5.9,5.9ZM20.425,15.19a5.309,5.309,0,0,0-2.949-4.754v9.5a5.278,5.278,0,0,0,2.949-4.742ZM17.476,4.845v2.43a8.26,8.26,0,0,1,0,15.83v2.43a10.609,10.609,0,0,0,0-20.69Z",
    transform: "translate(-4.616 -4.69)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaking);
export default __webpack_public_path__ + "static/media/speaking.4ee43ee9252ee89279c74245106f818c.svg";
export { ForwardRef as ReactComponent };